import { render, staticRenderFns } from "./Connect.vue?vue&type=template&id=2210cf88&scoped=true"
import script from "./Connect.vue?vue&type=script&lang=js"
export * from "./Connect.vue?vue&type=script&lang=js"
import style0 from "./Connect.vue?vue&type=style&index=0&id=2210cf88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2210cf88",
  null
  
)

export default component.exports